import React from 'react';
import ProductSeriesDetailMosaicMediaGallery from '../productSeriesDetailMosaicMediaGallery';
import { modelMediaGalleryClick, modelMediaGalleryVisible } from '../../constants/analytics.constants';

const ProductModelDetailMosaicMediaGallery = (props): JSX.Element => {

  return (
    <>
      <ProductSeriesDetailMosaicMediaGallery {...props} visibleEvent={modelMediaGalleryVisible}  galleryCardClickEvent={modelMediaGalleryClick}/>
    </>
  )
};

export default ProductModelDetailMosaicMediaGallery;
